function clickSwitcherButton (btn, targetBtn, activeClass, switcherState) {
  const switcher = document.getElementById('js-switcher-checkbox'),
        oneBtn = document.getElementById(btn),
        twoBtn = document.getElementById(targetBtn);

  if (switcher) {
    oneBtn.addEventListener('click', () => {
      twoBtn.classList.remove(activeClass);
      oneBtn.classList.add(activeClass);
      switcher.checked = switcherState;
      document.location = oneBtn.getAttribute('url');
    });
  }
}

function setActiveStateSwitcherButtons () {
  const switcher = document.getElementById('js-switcher-checkbox'),
        buyerButton = document.getElementById('js-switcher-buyer'),
        builderButton = document.getElementById('js-switcher-builder'),
        builderUrl = builderButton.getAttribute('url'),
        buyerUrl = buyerButton.getAttribute('url');

  if (switcher) {
    switcher.addEventListener('change', (e) => {
      if (e.target.checked) {
        buyerButton.classList.remove('--is-active');
        builderButton.classList.add('--is-active');
        document.location = builderUrl;
      } else {
        builderButton.classList.remove('--is-active');
        buyerButton.classList.add('is-active');
        document.location = buyerUrl;
      }
    });
  }
}

function clickToggle () {
  const btn = document.getElementById('js-toggle-menu'),
        collapse = document.getElementById('js-navigation-collapse'),
        list = document.getElementById('js-navigation-list'),
        search = document.getElementById('js-navigation-search'),
        topList = document.getElementById('js-navigation-top-list'),
        close = document.getElementById('js-navigation-close'),
        title = document.getElementById('js-navigation-title');

  if (btn) {
    btn.addEventListener('click', () => {
      if (title) {
        title.innerHTML = 'Menu';
      }
      if (list) {
        list.classList.remove('d-none');
      }
      if (search) {
        search.classList.add('d-none');
      }
      if (topList) {
        topList.classList.remove('d-none');
      }

      if (collapse) {
        setTimeout(() => {
          collapse.classList.remove('d-none');
        }, 1);
        setTimeout(() => {
          collapse.classList.add('--collapse-enter');
        }, 1);
        setTimeout(() => {
          collapse.classList.remove('--collapse-enter');
        }, 301);
      }

      btn.setAttribute('aria-expanded', 'true');
      if (close) {
        close.setAttribute('aria-expanded', 'true');
      }
    });
  }
}

function clickToggleSearch () {
  const btn = document.getElementById('js-toggle-search'),
        collapse = document.getElementById('js-navigation-collapse'),
        list = document.getElementById('js-navigation-list'),
        topList = document.getElementById('js-navigation-top-list'),
        close = document.getElementById('js-navigation-close'),
        title = document.getElementById('js-navigation-title');

  if (btn) {
    btn.addEventListener('click', () => {
      if (title) {
        title.innerHTML = 'Zoeken';
      }
      if(list) {
        list.classList.add('d-none');
      }
      if (topList) {
        topList.classList.add('d-none');
        topList.classList.remove('d-md-flex');
      }

      if (collapse) {
        setTimeout(() => {
          collapse.classList.remove('d-none');
        }, 1);
        setTimeout(() => {
          collapse.classList.add('--collapse-enter');
        }, 2);
        setTimeout(() => {
          collapse.classList.remove('--collapse-enter');
        }, 301);
      }

      btn.setAttribute('aria-expanded', 'true');
      if (close) {
        close.setAttribute('aria-expanded', 'true');
      }
    });
  }
}

function clickCloseCollapse () {
  const btn = document.getElementById('js-navigation-close'),
        toggleBtn = document.getElementById('js-toggle-menu'),
        searchBtn = document.getElementById('js-toggle-search'),
        collapse = document.getElementById('js-navigation-collapse'),
        list = document.getElementById('js-navigation-list'),
        search = document.getElementById('js-navigation-search'),
        topList = document.getElementById('js-navigation-top-list');

  if (btn) {
    btn.addEventListener('click', () => {
      if (collapse) {
        collapse.classList.add('--collapse-leave');
        setTimeout(() => {
          collapse.classList.add('d-none');
        }, 300);
      }
      setTimeout(() => {
        if (collapse) {
          collapse.classList.remove('--collapse-leave');
        }
        if (list) {
          list.classList.remove('d-none');
        }
        if(search) {
          search.classList.remove('d-none');
        }
        if(topList) {
          topList.classList.remove('d-none');
          topList.classList.add('d-md-flex');
        }
      }, 301);

      btn.setAttribute('aria-expanded', 'false');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
      if (searchBtn) {
        searchBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

function closeCollapse () {
  const btn = document.getElementById('js-navigation-close'),
        toggleBtn = document.getElementById('js-toggle-menu'),
        searchBtn = document.getElementById('js-toggle-search'),
        collapse = document.getElementById('js-navigation-collapse'),
        list = document.getElementById('js-navigation-list'),
        search = document.getElementById('js-navigation-search'),
        topList = document.getElementById('js-navigation-top-list'),
        xl = window.matchMedia('(min-width: 1280px)');

  if (xl.matches) {
    if (collapse) {
      collapse.classList.add('d-none');
    }
    if (list) {
      list.classList.remove('d-none');
    }
    if (search) {
      search.classList.remove('d-none');
    }
    if (topList) {
      topList.classList.remove('d-none');
    }
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
    }
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
    if (searchBtn) {
      searchBtn.setAttribute('aria-expanded', 'false');
    }
  }
}

function addClassNavBar () {
  const navBar = document.getElementById('js-navigation-bar');

  if (navBar) {
    navBar.classList.add('--has-shadow');
  }
}

function removeClassNavBar () {
  const navBar = document.getElementById('js-navigation-bar');

  if (navBar) {
    navBar.classList.remove('--has-shadow');
  }
}

export {
  clickSwitcherButton,
  setActiveStateSwitcherButtons,
  clickToggle,
  clickToggleSearch,
  clickCloseCollapse,
  closeCollapse,
  addClassNavBar,
  removeClassNavBar
};
